import React from 'react';
import ProductBanList from '../ProductBanList';
import ProductListSearchBox from '../../../common/ProductListSearchBox';

const ProductBanListWrap = (props) => {
  const {
    productBanList,
    categorySelectList,
    setData,
    getList,
    getExcelDownload,
    getProductTagColumnTagList,
    getProductSubCategoryList,
  } = props;

  return (
    <div className="product-ban-list-wrap">
      {/*상품 검색 박스*/}
      <ProductListSearchBox
        setData={(data) =>
          setData({
            path: ['productList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        setTagSearchList={(list) =>
          setData({
            path: ['productList', 'tagSearchList'],
            value: list,
          })
        }
        searchData={productBanList.searchData}
        tagGroupList={productBanList.tagGroupList}
        tagList={productBanList.tagList}
        tagSearchList={productBanList.tagSearchList}
        categorySelectList={categorySelectList}
        getList={getList}
      />

      {/* 상품 금지 리스트 */}
      <ProductBanList
        productBanList={productBanList}
        getList={getList}
        getExcelDownload={getExcelDownload}
        getProductTagColumnTagList={getProductTagColumnTagList}
        getProductSubCategoryList={getProductSubCategoryList}
      />
    </div>
  );
};

export default ProductBanListWrap;
